<template lang="html">
  <v-app>
    <v-main id="pagetop">
      <AppHeader />
      <router-view />
      <AppFooter />
    </v-main>
  </v-app>
</template>

<script>
  import AppHeader from "./components/AppHeader.vue";
  import AppFooter from "./components/AppFooter.vue";

  export default {
    name: "App",
    components: {
      AppHeader,
      AppFooter,
    },
  };
</script>

<style>
  h1 {
    text-align: center;
    font-family: "rocknroll-one", sans-serif;
    font-weight: 400;
    font-style: normal;
    margin: 30px auto;
    font-size: 3em;
    color: rgb(var(--v-theme-secondary));
  }
</style>
